import type { ReactNode } from 'react';
import CpmTooltip from './Tooltip';

interface CpmFieldLabelProps {
    children: ReactNode;
    required?: boolean;
    /** Inline caption next to the label (e.g. “Free text. More than one is fine.”). */
    hint?: ReactNode;
    /** Hover tooltip on an info icon. */
    tooltip?: ReactNode;
    className?: string;
}

function InfoIcon() {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="11" x2="12" y2="16.5" strokeLinecap="round" />
            <circle cx="12" cy="7.8" r="0.9" fill="currentColor" stroke="none" />
        </svg>
    );
}

/** Form-field label: sentence-case name, optional Required tag, hint, or info tooltip. */
export default function CpmFieldLabel({
    children,
    required = false,
    hint,
    tooltip,
    className = '',
}: CpmFieldLabelProps) {
    return (
        <div className={['flex items-center flex-wrap gap-1.5 min-h-[18px]', className].join(' ')}>
            <span
                style={{
                    fontSize: 13.5,
                    fontWeight: 800,
                    letterSpacing: '-0.01em',
                    color: '#111111',
                }}
            >
                {children}
            </span>
            {required ? (
                <span
                    className="uppercase"
                    style={{
                        fontSize: 9.5,
                        fontWeight: 800,
                        letterSpacing: '0.06em',
                        color: 'var(--cpm-error)',
                    }}
                >
                    Required
                </span>
            ) : null}
            {hint ? (
                <span
                    className="uppercase"
                    style={{
                        fontSize: 9.5,
                        fontWeight: 800,
                        letterSpacing: '0.05em',
                        color: '#111111',
                    }}
                >
                    {hint}
                </span>
            ) : null}
            {tooltip ? (
                <CpmTooltip content={tooltip} align="start" fit>
                    <span
                        className="inline-flex items-center justify-center text-[var(--cpm-text-tertiary)]"
                        style={{ width: 14, height: 14 }}
                    >
                        <InfoIcon />
                    </span>
                </CpmTooltip>
            ) : null}
        </div>
    );
}
